<template>
    <pillar-add-form></pillar-add-form>
</template>


<script>

    import PillarAddForm from '../../add/representations/WizardForm'

    export default {

        components:{
            PillarAddForm,
        },

    }
</script>

